import { Pipe, PipeTransform } from '@angular/core';

import { parseAssociationContactItemIcon, parseAssociationContactItemUrl } from '@cjm/v-loket/shared';

import { AssociationContactEntity, AssociationContactItem } from '../../../data';

@Pipe({
	name: 'mainContactInfo',
	standalone: true
})
export class MainContactInfoPipe implements PipeTransform {
	/**
	 * Finds the main location from an array of association contact info.
	 */
	public transform(contactInfo: AssociationContactEntity[]): AssociationContactItem[] {
		if (!Array.isArray(contactInfo) || contactInfo.length === 0) {
			return [];
		}

		return contactInfo.reduce((acc: AssociationContactItem[], item: AssociationContactEntity) => {
			if (!item.isPrimary) {
				return acc;
			}

			return [
				...acc,
				{
					label: item.contactValue,
					...parseAssociationContactItemIcon(item.contactType, item.contactValue),
					url: parseAssociationContactItemUrl(item.contactType, item.contactValue)
				}
			];
		}, []);
	}
}
